import { recordEvent } from "@/services/telemetry";
import type { PerfRollup, PerfSink } from "./types";

/**
 * Ships each rollup as one aggregated OTel event (`perf`-category, sampled).
 * Aggregation keeps volume flat regardless of user activity — one event per flush interval.
 */
export class OtelPerfSink implements PerfSink {
  public readonly name = "otel";
  public readonly isActive = true;

  public send(rollup: PerfRollup): void {
    recordEvent("perf.rollup", { perf: rollup as unknown as Record<string, unknown> }, "perf");
  }
}
